<template>
  <div class="add-new-org" :key="addNewOrgKey" v-if="$mq && (type === 'add' || type === 'edit' && organisation.ID)">
    <HeaderPanel
      class="add-new-org__header"
      header-icon="form-organisation-apioshade3"
      :header-text="headerText"
    >
    </HeaderPanel>
    <v-stepper @step="step" flat non-linear v-model="e1">
      <v-stepper-header>
        <v-stepper-step class="add-org-header__step" :complete="e1 > 1" step="1"
          ><apio-icon
            v-if="e1 > 1"
            darkModeColour="cyan"
            lightModeColour="cyan"
            name="ui-circle-tick-line"
            :size="iconSize"
            class="mr-4"
          />
          Organisation details</v-stepper-step
        >

        <v-stepper-step :complete="e1 > 2" step="2"
          ><apio-icon
            v-if="e1 > 2"
            class="add-org-header__step-icon"
            darkModeColour="cyan"
            lightModeColour="cyan"
            name="ui-circle-tick-line"
            :size="iconSize"
          />Address</v-stepper-step
        >

        <v-stepper-step step="3">Company details</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content @step="step" step="1">
          <org-details :organisation-details="organisation" @step="step" />
        </v-stepper-content>

        <v-stepper-content @step="step" step="2">
          <address-details :organisation-details="organisation" @step="step" />
        </v-stepper-content>

        <v-stepper-content @step="step" step="3">
          <company-details :organisation-details="organisation" @step="step" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
// import { required, minLength, email } from "vuelidate/lib/validators";
// import { validationMixin } from "vuelidate";

export default {
  name: "AddNewOrg",
  data() {
    return {
      e1: 1,
      type: this.$route.meta.type,
      stepComponent: this.$route.query.step || "org-details",
      title: "",
      organisation: {
        name: "",
        contact_email: "",
        contact_name: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        postcode: "",
        country_id: "",
        contact_number: "",
        company_registration_number: "",
        vat_number: "",
      },
      addNewOrgKey: Math.random(),
    };
  },
  components: {
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
    OrgDetails: () => import("@/components/Organisations/OrgDetails.vue"),
    AddressDetails: () =>
      import("@/components/Organisations/AddressDetails.vue"),
    CompanyDetails: () =>
      import("@/components/Organisations/CompanyDetails.vue"),
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    iconSize() {
      return this.$vuetify.breakpoint.lg ||
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.sm
        ? "20"
        : "32";
    },
    headerText() {
      return this.type === "edit"
        ? `You are editing ${this.organisation.name}`
        : "You're adding a new organisation";
    },
  },
  async created() {
    await this.$store.dispatch("fetchCountries");
    if (this.type === "edit") {
      await this.$store.dispatch(
        "fetchSingleOrganisation",
        this.$route.params.id
      );
      Object.assign(
        this.organisation,
        this.$store.state.orgs.currentOrganisation
      );
      this.$forceUpdate();
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    step(data) {
      const { org, step, complete = false } = data;
      Object.assign(this.organisation, org);
      this.e1 = step;
      this.scrollToTop();
      if (complete === true) {
        this.save();
      }
    },
    cancel() {
      this.$router.push("/");
    },
    async save() {
      if(this.$route.params.id) {
        await this.$store.dispatch("editOrganisation", {
          organisation: this.organisation,
        })
      } else {
        await this.$store.dispatch("createOrganisation", {
          organisation: this.organisation,
          timeStart: this.timestampStart,
          timeEnd: this.timestampEnd,
        }).then(({ status, text}) => {
          this.$store.state.mode.snackBarStatus = status;
          this.$store.state.mode.snackBarText = text;
          this.$store.state.mode.snackbar = true;
        })
      }

      this.$router.push("/dashboard");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
  display: block;
}

::v-deep .v-stepper__label {
  margin: 0 auto;
}

::v-deep div.v-stepper__step.v-stepper__step > span {
  display: none;
}

::v-deep
  .theme--light.v-stepper--non-linear
  .v-stepper__step:not(.v-stepper__step--error)
  .v-stepper__label {
  color: white;
}

::v-deep
  .theme--dark.v-stepper--non-linear
  .v-stepper__step--inactive
  .v-stepper__label,
::v-deep
  .theme--light.v-stepper--non-linear
  .v-stepper__step--inactive
  .v-stepper__label {
  color: var(--apio-shade-3) !important;
}

div.v-stepper__header > div.v-stepper__step.v-stepper__step--complete,
div.v-stepper__header > div.v-stepper__step.v-stepper__step--active {
  background: var(--apio-purple);
}

.theme--light.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label,
div.v-stepper__header > div.v-stepper__step.add-org-header__step.v-stepper__step--complete > div
div.v-stepper__header > div.v-stepper__step.add-org-header__step.v-stepper__step--active > div {
  color: white !important;
}

::v-deep .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
  display: flex;
  flex-direction: row;
  align-items: center;

  & > div {
    position: absolute;
    left: 28px;

    @media screen and (max-width: 768px) {
      left: 6px;
    }
  }
}

::v-deep
  div
  > div.v-stepper__header
  > div.v-stepper__step.v-stepper__step--inactive
  > div,
::v-deep
  div
  > div.v-stepper__header
  > div.v-stepper__step.v-stepper__step--active
  > div {
  margin: 0 auto;
}

.add-new-org {
  margin: 14px 32px;
  .theme--light.v-stepper {
    background: var(--apio-shade-5);
  }

  .theme--dark.v-stepper {
    background: var(--apio-shade-1);
  }

  &__step {
    display: flex;
  }

  .v-stepper {
    box-shadow: none;

    &__content {
      padding: 0;
    }

    &__header {
      box-shadow: none;
    }

    &__step {
      &__step {
        display: none;
      }
      width: 33.33%;
      font-size: 14px;
      font-weight: 700;
      background: white;
      border-radius: 100px;
      height: 48px;
    }

    &__step:not(:last-of-type) {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
      border-left: 1px solid var(--apio-shade-5);
    }

    &__step:not(:first-of-type) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-right: 1px solid var(--apio-shade-5);
    }

    &__step:first-of-type {
      border-left: 0;
    }

    &__step:last-of-type {
      border-right: 0;
    }
  }

  &__title {
    padding-bottom: 24px;
  }

  &__header {
    padding: 0 0 24px;
  }

  &__card {
    padding: 16px;
  }
}

@media screen and (min-width: 360px) and (max-width: 600px) {
  .add-new-org {
    .v-stepper {
      &__step:nth-child(1) {
        width: 41%;
      }
      &__step--complete:nth-child(1) {
        ::v-deep .v-stepper__label {
          margin: 8px 8px 8px auto;
        }
      }
      &__step:nth-child(2) {
        width: 28%;
      }
      &__step--complete:nth-child(2) {
        ::v-deep .v-stepper__label {
          margin: auto 4px auto auto;
        }
      }
      &__step:nth-child(3) {
        width: 30.5%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .add-new-org {
    .v-stepper {
      &__step {
        padding: 0;
        &__step {
          display: none;
        }
        font-size: 10px;
        font-weight: bold;
        background: white;
        border-radius: 100px;
        height: 32px;
      }

      &__step:nth-child(1) {
        width: 41.5%;
      }
      &__step:nth-child(2) {
        width: 22%;
      }
      &__step:nth-child(3) {
        width: 36.5%;
      }
    }
  }
}
</style>
